import { GalleryLightboxShowContent } from '@website-builder/editor/sidebar/edit-components/gallery-edit/models/gallery-lightbox-content.type';

export class GalleryLightboxStyle {
  enabled = false;
  showControlsAlways = false;
  showCounter = false;
  closeOnBgClick = true;
  animation = 'slide';
  navigation = 'slidenav';
  textColor = 'uk-color-black';
  showContent: GalleryLightboxShowContent = 'overlay-lightbox';

  static normalize(styles: Partial<GalleryLightboxStyle>): GalleryLightboxStyle {
    const pureStyles = new GalleryLightboxStyle();

    pureStyles.enabled = styles.enabled ?? pureStyles.enabled;
    pureStyles.showControlsAlways = styles.showControlsAlways ?? pureStyles.showControlsAlways;
    pureStyles.showCounter = styles.showCounter ?? pureStyles.showCounter;
    pureStyles.closeOnBgClick = styles.closeOnBgClick ?? pureStyles.closeOnBgClick;
    pureStyles.animation = styles.animation ?? pureStyles.animation;
    pureStyles.navigation = styles.navigation ?? pureStyles.navigation;
    pureStyles.textColor = styles.textColor ?? pureStyles.textColor;
    pureStyles.showContent = styles.showContent ?? pureStyles.showContent;

    return pureStyles;
  }
}
